// extracted by mini-css-extract-plugin
export var link = "CategoriesCard-module--link--1BKMZ";
export var subjectContainer = "CategoriesCard-module--subjectContainer--1pLD6";
export var subjectImg = "CategoriesCard-module--subjectImg--25ay1";
export var subjectTitle = "CategoriesCard-module--subjectTitle--1eXBL";
export var content = "CategoriesCard-module--content--1HUdj";
export var contentTitle = "CategoriesCard-module--contentTitle--h-gvS";
export var contentBodyContainer = "CategoriesCard-module--contentBodyContainer--2xvMy";
export var contentBody = "CategoriesCard-module--contentBody--3HDS3";
export var contentButton = "CategoriesCard-module--contentButton--HXmcv";